@if (group(); as productGroup) {
  <em-box class="!flex flex-col bg-white" size="sm">
    @if (showTags) {
      <div class="absolute right-14" style="top: -3px">
        @if (group()?.isGoogleSPD) {
          <em-tag [displayAsLabel]="true" color="primary">{{
            'SHARED_LABEL_AUTOMATED_DISCOUNT' | translate
          }}</em-tag>
        } @else if (group()?.isPriceCrawl) {
          <em-tag [displayAsLabel]="true" color="info">{{
            'NAV_COMPETITORS_RADAR' | translate
          }}</em-tag>
        }
      </div>
    }

    <div class="flex gap-2 items-center">
      <div class="flex-auto">
        <span class="font-semibold text-titleColor">{{
          productGroup.name | productGroupName
        }}</span>
        @if (totalProductsCount(); as totalProductsCount) {
          <span class="ml-4 mr-2 text-xs">|</span>
          <span
            class="text-sm hover:text-primary-400 underline cursor-pointer whitespace-nowrap"
            (click)="toProducts(productGroup)"
          >
            <span translate>LABEL_PRODUCTS</span>:

            @if (isLoadingCount$ | async) {
              <em-three-dots-loading
                size="xs"
                class="ml-2"
              ></em-three-dots-loading>
            } @else {
              <span class="">
                {{ groupProductsCount() }} / {{ totalProductsCount }}
              </span>
              <span class="font-bold">
                ({{ productPercentage() | percent: '0.0-2' }})</span
              >
            }
          </span>
        }
      </div>

      @if (!compactView) {
        <div class="-mt-3 -mr-3 ml-auto">
          <em-icon-button
            icon="more_vert"
            color=""
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
          >
          </em-icon-button>
        </div>
      }
    </div>
    <hr />
    <div
      class="grid items-top text-sm mt-2"
      style="grid-template-columns: 35px 1fr"
    >
      @if (conditionalStatementList(); as conditionalStatementList) {
        <div>
          <mat-icon
            class="section-icon"
            [matTooltip]="'PRODUCT_FILTER_TITLE_AUTOMATIC' | translate"
            matTooltipPosition="left"
            >filter_list</mat-icon
          >
        </div>
        <div class="content-col">
          <em-readable-filters
            [filters]="conditionalStatementList"
          ></em-readable-filters>
        </div>
      }

      @if (productGroup.excludeSetId) {
        <div>
          <mat-icon
            class="section-icon"
            [matTooltip]="'PRODUCT_FILTER_TITLE_EXCLUDE_FITLER_SET' | translate"
            matTooltipPosition="left"
            >filter_list_off</mat-icon
          >
        </div>
        <div class="content-col">
          <div class="condition-pill inline-flex gap-2">
            <span class="italic"
              >{{
                'PRODUCT_FILTER_TITLE_EXCLUDE_FITLER_SET' | translate
              }}:</span
            >
            <strong>{{ productGroup.excludeSetName ?? '' | translate }}</strong>
          </div>
        </div>
      }

      @if (
        productGroup.manuallyAddedProducts.length ||
        productGroup.manuallyRemovedProducts.length
      ) {
        <div class="">
          <mat-icon
            class="section-icon"
            [matTooltip]="'PRODUCT_FILTER_TITLE_MANUAL' | translate"
            matTooltipPosition="left"
            >format_list_bulleted_add</mat-icon
          >
        </div>
        <div class="content-col">
          <div class="mt-1 flex items-center">
            @if (productGroup.manuallyAddedProducts.length) {
              <div class="condition-pill flex items-center text-sm italic mr-2">
                <em-icon
                  name="add_circle_outline"
                  size="sm"
                  class="text-success-500"
                ></em-icon
                ><span
                  >{{ 'FILTER_MANUAL_INCLUDED' | translate }} ({{
                    productGroup.manuallyAddedProducts.length
                  }})</span
                >
              </div>
            }
            @if (productGroup.manuallyRemovedProducts.length) {
              <div class="condition-pill flex items-center text-sm italic">
                <em-icon
                  name="remove_circle"
                  size="sm"
                  class="text-danger-500"
                ></em-icon
                ><span
                  >{{ 'FILTER_MANUAL_EXCLUDED' | translate }} ({{
                    productGroup.manuallyRemovedProducts.length
                  }})</span
                >
              </div>
            }
          </div>
        </div>
      }

      @if (appliedCampaigns.length > 0) {
        <div class="">
          <mat-icon
            class="section-icon"
            [matTooltip]="'PRODUCT_FILTER_CAMPAIGNS_USAGE' | translate"
            matTooltipPosition="left"
            >campaign</mat-icon
          >
        </div>
        <div class="content-col">
          @if (isLoadingCampaigns$ | async) {
            <div>
              <em-three-dots-loading size="xs"></em-three-dots-loading>
            </div>
          } @else {
            <ul class="mt-1">
              @for (campaign of appliedCampaigns$ | async; track campaign) {
                <li
                  class="flex items-center"
                  [ngClass]="{
                    'text-red-500': campaign.attributes?.invertedProducts,
                  }"
                >
                  <img
                    class="platform-icon inline"
                    [src]="platformIcon(campaign.platform)"
                  />{{ campaign.name }}
                  <em-more-info
                    class="ml-2"
                    [maxWidth]="400"
                    [description]="
                      campaign.attributes?.invertedProducts
                        ? 'CAMPAIGN_PRODUCTGROUP_TOOLTIP_INVERTED'
                        : 'CAMPAIGN_PRODUCTGROUP_TOOLTIP'
                    "
                  >
                  </em-more-info>
                </li>
              }
            </ul>
          }
        </div>
      }
    </div>
  </em-box>

  <mat-menu #menu="matMenu">
    @if (allowEdit) {
      <button mat-menu-item (click)="editGroup(productGroup)">
        <div class="flex items-center">
          <em-icon name="edit"></em-icon>
          <span>{{ 'PRODUCT_FILTER_EDIT_SET' | translate }}</span>
        </div>
      </button>
    }
    @if (allowDuplicate) {
      <button mat-menu-item (click)="duplicateGroup(productGroup)">
        <div class="flex items-center">
          <em-icon name="content_copy"></em-icon>
          <span>{{ 'SHARED_LABEL_DUPLICATE' | translate }}</span>
        </div>
      </button>
    }
    @if (productGroup.country) {
      <button
        mat-menu-item
        [routerLink]="['/export-products/add']"
        [queryParams]="{
          group_uuid: productGroup.uuid,
          country: productGroup.country,
          name: productGroup.name + ' - CSV',
        }"
      >
        <div class="flex items-center">
          <em-icon name="file_upload" color=""></em-icon>
          <span>{{ 'NAV_EXPORT_CSV' | translate }}</span>
        </div>
      </button>
    }
    @if (isAdmin()) {
      <button mat-menu-item (click)="downloadProductsCSV(productGroup)">
        <div class="flex items-center">
          <em-icon name="download"></em-icon>
          <span>{{
            'PRODUCT_FILTER_SET_DOWNLOAD_PRODUCTS_CSV' | translate
          }}</span>
        </div>
      </button>
    }
    @if (allowDelete) {
      <button mat-menu-item (click)="deleteGroup(productGroup)">
        <div class="flex items-center">
          <em-icon name="delete" color="warn"></em-icon>
          <span>{{ 'PRODUCT_FILTER_SET_DELETE' | translate }}</span>
        </div>
      </button>
    }
  </mat-menu>
}
